import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryPaymentColumn } from '../constants/dictionary-payment-columns.constant';
import CustomButton from '../../../../v2-components/Antd/Button';

export const generatePaymentColumns = (onViewVoucher) => {
	return [
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].payment_date,
			dataIndex: 'payment_date',
			key: 'payment_date',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].products_total,
			dataIndex: 'products_total',
			key: 'products_total',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].shipping_total,
			dataIndex: 'shipping_total',
			key: 'shipping_total',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].general_total,
			dataIndex: 'general_total',
			key: 'general_total',
		},
		{
			title: dictionaryPaymentColumn[Enviroment.LANGUAGE].payment_method,
			key: 'voucher',
					render: (text, record) => (
				<CustomButton 
					onClick={() => onViewVoucher?.(record.payment_tracking_id)}
					style={{ 
						backgroundColor: 'transparent', 
						color: '#0066CC',
						border: 'none',
						padding: 0,
						fontSize: '14px',
						textDecoration: 'underline',
						cursor: 'pointer'
					}}
					loading={false}
				>
					Comprobante de pago
				</CustomButton>
			),
		
		},
		
	];
};
